import { useId } from 'react';
import Tooltip from 'components/tooltips/Tooltips';

// The shared Tooltip only listens to the mouse: focus replays its events so
// the keyboard shows the same bubble, at the same place.
const replay = (type) => (event) =>
  event.currentTarget.dispatchEvent(new MouseEvent(type, { bubbles: true }));
const showOnFocus = replay('mouseover');
const hideOnBlur = replay('mouseout');
const hideOnEscape = (event) => {
  if (event.key === 'Escape') hideOnBlur(event);
};

/**
 * A badge with its tooltip (JBWEB-1272): shown on hover and on focus, and
 * read by screen readers as the badge's description. Without a text, the
 * badge alone.
 */
const BadgeTooltip = ({ text, children }) => {
  const tooltipId = useId();
  if (!text) return children;

  return (
    <Tooltip
      placement="top"
      text={
        <span id={tooltipId} role="tooltip">
          {text}
        </span>
      }
    >
      <div
        tabIndex={0}
        aria-describedby={tooltipId}
        onFocus={showOnFocus}
        onBlur={hideOnBlur}
        onKeyDown={hideOnEscape}
        className="rounded cursor-help focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400"
      >
        {children}
      </div>
    </Tooltip>
  );
};

export default BadgeTooltip;
